(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('GenreIbqDeleteController',GenreIbqDeleteController);

    GenreIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Genre'];

    function GenreIbqDeleteController($uibModalInstance, entity, Genre) {
        var vm = this;

        vm.genre = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Genre.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
